import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { EntityReferenceBasic, TagLabel } from '@/shared/types';

import type { TagDetailItem } from '@/entities/tags/domain';

type CreateTagRequest = {
  classification: string;
  parent?: string;
  name: string;
  displayName?: string;
  description?: string;
  style?: {
    color?: string;
    iconURL?: string;
  };
  mutuallyExclusive?: boolean;
  owners?: EntityReferenceBasic[];
  domains?: string[];
  tags?: TagLabel[];
  provider?: 'system' | 'user';
};

export const createTagApi = async (request: CreateTagRequest): Promise<TagDetailItem> => {
  const { data } = await openMetadataApiClient.put<TagDetailItem>('/tags', request);
  return data;
};

export type { CreateTagRequest };
